export default {"src":"/_next/static/media/male_3.af606d25.svg","height":144,"width":145,"blurWidth":0,"blurHeight":0};